import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Spin } from 'antd';
import { useAppStore } from '../../stores';
import { AppHeader, WorksheetsPanel, WorksheetsRenderer } from '../../components';
import { CustomDivider, DocumentPreview, ErrorsRenderer } from '../../../custom_shared/components';
import './AccountingStatementAppScreen.less';
import '../../../custom_shared/styles/common.less';

const AccountingStatementAppScreen: React.FC = () => {
    const appStore = useAppStore();

    const { sessionStore, worksheetsSubmissionStore, documentPreviewStore, documentVisualStore } = appStore;

    React.useEffect(() => {
        sessionStore.initialize();
    }, [sessionStore]);

    React.useEffect(() => {
        return () => appStore.dispose();
    }, [appStore]);

    return (
        <div className="accounting-statement-app-screen">
            <div className="top-container">
                <AppHeader />

                {sessionStore.errorsWithDetails.length > 0 && (
                    <ErrorsRenderer errors={sessionStore.errorsWithDetails} />
                )}
            </div>

            <CustomDivider type="horizontal" />

            <div className={`bottom-container preview-position-${documentPreviewStore.previewPosition}`}>
                <div className={`bottom-left-container ${documentPreviewStore.fullScreenMode ? 'expanded' : ''}`}>
                    {sessionStore.isInitializing || worksheetsSubmissionStore.isInitializing ? (
                        <div className="loading-overlay">
                            <Spin size="large" />
                        </div>
                    ) : (
                        <div className="worksheets-container">
                            <WorksheetsPanel />
                            <CustomDivider type="vertical" />
                            <WorksheetsRenderer />
                        </div>
                    )}
                </div>

                {!documentPreviewStore.fullScreenMode && <CustomDivider type="vertical" />}

                <div className={`bottom-right-container ${documentPreviewStore.fullScreenMode ? 'hidden' : ''}`}>
                    <DocumentPreview
                        appStore={appStore}
                        documentVisualStore={documentVisualStore}
                        documentPreviewStore={documentPreviewStore}
                        sessionStore={sessionStore}
                        showPageNumbers
                        lightMode
                    />
                </div>
            </div>
        </div>
    );
};

export default observer(AccountingStatementAppScreen);
